// Constants
import { GET_INVITATION_CODES, RESET_DEFAULT_STATE } from '~/data/constants/authentication-constants';

import { GET_MY_TEAM, UPDATE_TEAM_NAME } from '~/data/constants/profile-constants';
import { HIDE_MODAL } from '~/data/constants/modal-constants';

// SERVICES
import ProfileService from '~/data/services/profiles-services';
import AuthenticationService from '~/data/services/authentication-service';

import { history } from '~/helpers/history';
import { UPDATE_EMAIL } from '~/data/constants/profile-constants';
import { INDEX_URL } from '~/data/constants/router-constants';

/**
 * Updates the User's Phone Number (MSISDN)
 *
 * @export
 * @param {*} companyID
 * @returns
 */
export function updateUserMsisdn(companyID) {
	return ProfileService.updateUserMsisdn(companyID);
}

/*  The response data must be coherent with the expected data on the My Team page.
		So, altough the members array only displays the list of existing members,
		we must normalize the array to include a maximum of 10 empty placeholders.
*/
function fillTeamArrayWithPlaceholders(data) {
	if (data.members.length < 9) {
		for (let i = data.members.length; i <= 9; i++) {
			data.members.push({
				id: undefined,
				photoUrl: undefined,
				nick: undefined,
			});
		}
	}

	return data;
}

/**
 * Updates the User's Phone Number (MSISDN)
 *
 * @export
 * @param {*} companyID
 * @returns
 */
export function updateMyTeamsName(teamid, teamname) {
	return dispatch => {
		ProfileService.updateMyTeamsName(teamid, teamname)
			.then(response => {
				if (response.data) {
					let data = fillTeamArrayWithPlaceholders(response.data);
					dispatch(updateStore(data));
				} else {
					console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the my team info');
				}
			});
	};

	function updateStore(team) {
		return {
			type: UPDATE_TEAM_NAME,
			myTeam: team,
		};
	}
}
export function putMyProfileEmail(email, callbackSuccess, callbackError) {
	ProfileService.updateUserEmail(email)
		.then(response => {
			callbackSuccess();
			return true;
		})
		.catch(error => {
			if (error.response === undefined) {
				return console.error('Response is undefined');
			} else if (error.response.status === 400) {
				return console.error('Response is invalid');
			} else {
				console.error('Error returning the my team info');
			}
			callbackError();
			return false;
		});
}

/**
 * Updates the User's Phone Number (MSISDN)
 *
 * @export
 * @param {*} companyID
 * @returns
 */
export function updateMyProfileEmail(email) {
	return dispatch => {
		dispatch(updateStore(email));
	};

	function updateStore(email) {
		return {
			type: UPDATE_EMAIL,
			contactEmail: email,
		};
	}
}
/**
 * Fetches the list of invitation codes
 *
 * @export
 * @returns
 */
export function getInvitationCodes() {
	return dispatch => {
		ProfileService.getInvitationCodes()
			.then(response => {
				// The response comes positive if the users profile data is returned
				if (response.data) {
					dispatch(updateStore(response.data));
				}
				// If something else is returned...
				else {
					console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				} else {
					console.error('Error returning the list of invitation codes');
				}
			});
	};

	function updateStore(invitationCodes) {
		return {
			type: GET_INVITATION_CODES,
			invitationCodes: invitationCodes,
		};
	}
}

/**
 * Fetches the my team info
 *
 * @export
 * @returns
 */
export function getMyTeam() {
	return dispatch => {
		ProfileService.getMyTeam()
			.then(response => {
				if (response.data) {
					let data = response.data;
					const maximum = 9;
					/*  The response data must be coherent with the expected data on the My Team page.
              So, altough the members array only displays the list of existing members,
              we must normalize the array to include a maximum of 10 empty placeholders.
          */
					if (data.members.length < maximum) {
						for (let i = data.members.length; i <= maximum; i++) {
							data.members.push({
								id: undefined,
								photoUrl: undefined,
								nick: undefined,
							});
						}
					}

					dispatch(updateStore(data));
				} else {
					console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				if (error.response === undefined) {
					return console.error('Response is undefined');
				} else if (error.response.status === 400) {
					return console.error('Response is invalid');
				}

				// 404 means that there is no team associated with
				// Ex: User has been kicked out of one
				else if (error.response.status === 404) {
					dispatch(updateStore(null));
				} else {
					console.error('Error returning the my team info');
				}
			});
	};

	function updateStore(myTeam) {
		return {
			type: GET_MY_TEAM,
			myTeam: myTeam,
		};
	}
}

/**
 * Deletes the user account from the database
 *
 * @export
 * @returns
 */
export function deleteUserAccount() {
	return dispatch => {
		ProfileService.deleteUserAccount()
			.then(() => {
				dispatch(hideModal());
				return AuthenticationService.doTheLogOut();
			})
			.then(response => {
				if (response.status === 200) {
					console.info('response status: ', response.status);
					dispatch(updateStore());

					setTimeout(() => {
						history.push({ pathname: INDEX_URL });
					}, 16);
				} else {
					return console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				console.error(error.stack);
			});
	};

	function hideModal() {
		return {
			type: HIDE_MODAL,
		};
	}

	function updateStore() {
		return {
			type: RESET_DEFAULT_STATE,
		};
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/profile-actions.jsx